import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Calculator, ArrowRight, ArrowLeft, LogOut } from 'lucide-react';

const SESSION_KEY = 'admin_authenticated';

const simulateurs = [
  {
    id: 'amz-cosmdz',
    title: 'Simulateur AMZ CW.Dz',
    description: 'Simulateur Amazon — Calcul de marge et du prix cible pour le marché DZ',
    path: '/admin/simulateurs/amz-cosmdz'
  },
  {
    id: 'amz-cosmfr',
    title: 'Simulateur AMZ CW.Fr',
    description: 'Simulateur Amazon — Calcul de marge et du prix cible pour le marché FR',
    path: '/admin/simulateurs/amz-cosmfr'
  },
  {
    id: 'amz-ads',
    title: 'Simulateur Amazon Ads',
    description: 'Stratégie publicitaire Amazon Ads personnalisée par phase (Lancement, Croissance, Optimisation)',
    path: '/admin/simulateurs/amz-ads'
  },
  {
    id: 'marges-physique',
    title: 'Simulateur Marges Physique',
    description: 'Calcul de marge circuit physique — Direct vs Distributeur, Forward et Reverse',
    path: '/admin/simulateurs/marges-physique'
  }
];

export default function AdminSimulateurs() {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) !== 'true') {
      navigate('/admin');
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    navigate('/admin');
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Simulateurs Admin - Cosmos Wave</title>
      </Helmet>
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-between items-center mb-8">
            <div>
              <Button variant="ghost" asChild className="mb-4">
                <Link to="/admin/cx-lab">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Retour au CX Lab
                </Link>
              </Button>
              <h1 className="text-3xl font-bold mb-2">Simulateurs Admin</h1>
              <p className="text-muted-foreground">
                Accédez aux différents simulateurs disponibles
              </p>
            </div>
            <Button variant="outline" onClick={handleLogout}>
              <LogOut className="w-4 h-4 mr-2" />
              Déconnexion
            </Button>
          </div>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {simulateurs.map((sim) => (
              <Card key={sim.id} className="hover:shadow-lg transition-shadow">
                <CardHeader>
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                    <Calculator className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle>{sim.title}</CardTitle>
                  <CardDescription>{sim.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <Button asChild className="w-full group">
                    <Link to={sim.path}>
                      Ouvrir le simulateur
                      <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
